import { useState as t, useEffect as e, cloneElement as n } from "react";

const r = ({children: r, delay: i = 500, visible: o = !0, unmount: u = !1}) => {
    const [c, l] = t(o);
    o && !c && l(!0);
    const s = !o && c;
    /* inert does not allow element to be focused; useful in situations when element is about to be hidden; */
    return e((() => {
        if (s) {
            const t = setTimeout(l, i, !1);
            return () => clearTimeout(t);
        }
    }), [ s ]), c ? o ? r : n(r, {
        inert: ""
    }) : u ? null : n(r, {
        inert: "",
        hidden: !0
    });
};

export { r as default };
//# sourceMappingURL=index.js.map
